<template>
  <div class="tree-select-modal" :style="{ zIndex: 4 }">
    <transition :name="transName('fade')">
      <div
        class="tree-select-modal-mask animated"
        @touchmove="onTouchMove($event)"
        @click="close()"
        v-if="showBody"
      ></div>
    </transition>
    <transition :name="transName('slide-up')">
      <div class="tree-select-modal-body animated" v-if="showBody && !showSelectedModal">
        <div class="head-container">
          <base-title
            ref="titleContainer"
            v-model="keyword"
            :title="_title"
            :show-close="true"
            :is-searching-mode="isFocusingSearch"
            :placeholder="searchPlaceholder"
            :searchTips="
              !isFocusingSearch ? '' : $t('commonForm-1.key727', { cm: '用“空格”分隔多个关键词，搜索更准确' })
            "
            :right-text="isMultiple ? $t('common.key10', { cm: '清空' }) : ''"
            use-search
            show-border-radius
            @focus="focusSearch"
            @cancel-search="cancelSearch"
            @right-click="clearAll"
            @left-click="close"
            :right-style="_clearTextStyle"
          >
          </base-title>
          <div v-if="showDepartmentPathFixed && !isFocusingSearch" style="position: relative; z-index: 100">
            <bread-crumb
              :list="isFocusingSearch ? searchSelectedPath : selectedPath"
              :labelKey="labelKey"
              :spreadTreeItem="spreadTreeItem"
            >
            </bread-crumb>
          </div>
        </div>
        <div class="value-list-content" :style="{ height: listHeight }">
          <div
            class="scroller-container scroller-content"
            :class="{ 'has-footer': isMultiple }"
            v-if="selectListShow && !isFocusingSearch"
          >
            <hly-scroll
              ref="scroller"
              :height="'100%'"
              :pull-down-refresh="!forbidRefresh"
              :pull-up-load="hasMore"
              @pulling-down="refresh"
              @pulling-up="loadMore"
              @onScroll="listenOnScroll"
            >
              <div class="data-list" :style="{ minHeight: bodyHeight }">
                <history-group
                  :title="$t('common.key136', { cm: '历史选择' })"
                  v-if="historyList.length && useHistory"
                  :clear-button-text="$t('global-1.key41', { cm: '清空历史' })"
                  :show-key="labelKey"
                  :list="historyList"
                  :show-recommended-text="false"
                  :selected="curSelectedResults"
                  :compared-key="valueKey"
                  show-margin-bottom
                  @click-item="selectTreeItem"
                  @clear-history="clearHistory"
                />
                <bread-crumb
                  v-if="!_trimKeyword && selectedPath.length > 1"
                  :list="selectedPath"
                  :labelKey="labelKey"
                  :spreadTreeItem="spreadTreeItem"
                >
                </bread-crumb>
                <div class="blank-viewer" v-if="depControl && !pagingList.length && !loadingDepartmentData">
                  <div class="blank-icon">
                    <svg-icon type="dep-no-info" class="blank-icon-svg" />
                  </div>
                  <div class="blank-text">
                    {{ $t('commonForm-1.key724', { cm: '根据公司政策要求，请搜索后选择' }) }}
                  </div>
                </div>

                <base-loading :type="'FIXED'" v-if="loadingDepartmentData"></base-loading>

                <tree-item-list
                  v-if="pagingList.length"
                  :pagingList="pagingList"
                  :selectTreeItem="selectTreeItem"
                  :spreadTreeItem="spreadTreeItem"
                  :curSelectedResults="curSelectedResults"
                  :valueKey="valueKey"
                  :disabledFunc="disabledFunc"
                  :hideItemFunc="hideItemFunc"
                  :vuexConfig="vuexConfig"
                >
                  <template slot="name" slot-scope="{ item }">
                    <component :is="componentName" :value="item" :userInfo="vuexConfig.userInfo" />
                  </template>
                </tree-item-list>
              </div>
            </hly-scroll>
          </div>
          <div
            class="search-result-container scroller-content"
            :class="{ 'has-footer': isMultiple }"
            v-if="isFocusingSearch"
          >
            <hly-scroll
              ref="searchScroller"
              :height="'100%'"
              :pull-down-refresh="false"
              :pull-up-load="searchHasMore"
              @pulling-up="loadMoreResult"
            >
              <div class="data-list">
                <div v-if="isFocusingSearch" style="position: relative; z-index: 100">
                  <bread-crumb
                    v-if="searchSelectedPath.length"
                    :list="searchSelectedPath"
                    :spreadTreeItem="spreadTreeItem"
                  >
                  </bread-crumb>
                </div>
                <tree-item-list
                  v-if="pagingSearchResult.length"
                  :pagingList="pagingSearchResult"
                  :selectTreeItem="selectTreeItem"
                  :spreadTreeItem="spreadTreeItem"
                  :curSelectedResults="curSelectedResults"
                  :valueKey="valueKey"
                  :disabledFunc="disabledFunc"
                  :hideItemFunc="hideItemFunc"
                >
                  <template slot="name" slot-scope="{ item }">
                    <component :is="searchComponentName" :value="item" :keyword="_trimKeyword" />
                  </template>
                </tree-item-list>
                <div class="blank-viewer" v-if="!pagingSearchResult.length && !loadingSearchData">
                  <div class="blank-icon">
                    <svg-icon :type="_trimKeyword ? 'dep-no-result' : 'dep-no-search'" class="blank-icon-svg" />
                  </div>
                  <div class="blank-text">
                    <div class="blank-text-title" v-if="_trimKeyword">
                      {{ $t('commonForm-1.key732', { cm: '未搜到相关结果' }) }}
                    </div>
                    {{
                      !_trimKeyword
                        ? $t('commonForm-1.key728', { cm: '输入关键词开始搜索' })
                        : $t('commonForm-1.key729', { cm: '调整上方关键词，重新尝试搜索' })
                    }}
                  </div>
                </div>
                <base-loading :type="'FIXED'" v-if="loadingDepartmentData"></base-loading>
              </div>
            </hly-scroll>
          </div>
          <div class="select-popup-bottom" ref="bottomContainer" v-if="isMultiple">
            <div class="selected-num-text" @click="openSelectedModal">
              {{ $t('common.key94', { cm: '已选' }) + ' ' + curSelectedLength }}
              <img :src="arrow" class="selected-arrow" />
            </div>
            <div class="select-ensure" @click="ensure">
              {{ $t('common.key8', { cm: '确定' }) }}
            </div>
          </div>
        </div>
      </div>
      <div class="tree-select-modal-body animated" v-if="showSelectedModal">
        <base-title
          :title="_title"
          :right-text="$t('common.key10', { cm: '清空' })"
          show-border-radius
          hide-btm-border
          show-box-shadow
          :show-grey-arrow="true"
          @right-click="clearAll"
          @left-click="showSelectedModal = false"
          :right-style="_clearTextStyle"
        >
        </base-title>
        <div class="scroller-container selected-page-con">
          <div class="page-con-scroll">
            <div class="department-list">
              <div
                v-for="item in curSelectedResults"
                :key="item[valueKey]"
                class="department-item department-item-selected"
              >
                <div class="department-item-name half-px-border">
                  <div :class="{ 'department-name': true, clamp: !keyword }">
                    {{ item[labelKey] }}
                  </div>
                  <div class="delete-icon" @click="deleteItem(item)"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script type="text/ecmascript-6">
/**
 * 树形选择弹框，目前已经接入部门（待接入部分，成本中心，值列表，项目任务）
 * todo 成本中心，值列表，项目任务的懒加载部分和统一高亮
 */

import store from '@/vuex';
import arrow from 'assets/images/application/travel/arrow-right@3x.png';
import BaseTitle from 'components/base-ui/base-title';
import hlyScroll from 'components/business/hly-scroll';
import baseLoading from 'components/base-ui/base-loading';
import EmptyContent from 'components/base-ui/empty-content';
import TreeItemList from 'components/base-ui-v3/tree-select/item-list/tree-item-list.vue';
import BreadCrumb from 'components/base-ui-v3/tree-select/bread-crumb/bread-crumb.vue';
import historyMixin from 'src/service/vue-mixin/history.mixin';
import {coreMap, treeCore, TREEMap} from '../util/core';
import debounce from 'lodash.debounce';
import HistoryGroup from 'components/base-ui/history-group';
import DepartmentItem from 'src/components/base-ui-v3/select-department/department-item.vue';
import DepartmentSearchItem from 'src/components/base-ui-v3/select-department/department-search-item';

let treeCoreObj;
let treeRootPath;

export default {
  name:'tree-select-modal',
  components: {
    BaseTitle,
    hlyScroll,
    baseLoading,
    EmptyContent,
    TreeItemList,
    BreadCrumb,
    HistoryGroup,
    DepartmentItem,
    DepartmentSearchItem
  },
  props: {
    treeTypeKey:{
      type: String,
      default:'default',
      description:'选择树形core的的核心key，目前分为部门和默认'
    },
    value: {
      type: Array,
    },
    valueKey:{
      type: String,
      default:'id'
    },
    labelKey:{
      type: String,
      default:'name'
    },
    extraParams: {
      type: Object,
      default: () => ({}),
    },
    single: {
      type: Boolean,
      default: false,
    },
    maxNum: {
      type: Number,
    },
    zIndex: {
      type: Number,
    },
    disabledKey: {
      type: String,
      default: '',
    },
    // disabledFunc:{
    //   type:Function,
    //   // default:()=>{
    //   //   return false
    //   // }
    // },
    // 是否阻止刷新
    forbidRefresh: {
      type: Boolean,
      default: false
    },
    useHistory: { //是否使用 历史记录（后端存值）
      type: Boolean,
      default: false
    },
    searchPlaceholder:{
      type: String,
    },
    // 谨慎使用，使用之后不会去调接口
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    depControl:{
      type: Boolean,
      default: false,
      description: '安全性控制'
    },
    vuexConfig:{
      type:Object,
      default:()=>{
        return {};
      }
    },
    functionMap:{
      type:Object,
      default:()=>{
        return {};
      }
    },
  },
  mixins: [historyMixin],
  data() {
    return {
      arrow,
      page:0,
      searchPage:0,
      showBody:false,
      isFocusingSearch:false,
      selectListShow: false,
      listHeight:'',
      bodyHeight:'',
      keyword:'',
      selectedPath: [],
      searchSelectedPath:[],
      showDepartmentPathFixed: false,
      curSelectedLength: 0,
      loadingDepartmentData:false,
      loadingSearchData:false,
      focusAnimateTimer: undefined,
      resultList:[],//列表数据
      curSelectedResults: [], // 选择列表
      showSelectedModal:false,
      searchResult:[],//搜索列表数据
      useWatch:true,//historyMixIn需要 勿动
      showValueList:false,//historyMixIn需要 勿动
      entityName: 'DEPARTMENT', //historyMixIn需要 勿动
      keyName: 'departmentOID', //historyMixIn需要 勿动
      componentName:'tree-item',
      searchComponentName:'tree-item'
    };
  },
  mounted() {
    this.pushOpeningModal(
      (this.popFn = () => {
        this.$emit('onCancel');
      })
    );
    this.showBody = true;
    setTimeout(() => {
      this.showSelectedModal = false;
      this.selectListShow=true;
      this.componentName=this.getComponentName();
      this.searchComponentName=this.getSearchComponentName();
      this.showValueList=this.useHistory;//showValueList为historyMixIn需要，不要重复声明
      this.initSelectedItems(this.value);
      this.updateListHeight();
      treeCoreObj = new (coreMap[this.treeTypeKey] || treeCore)({valueKey: this.valueKey,labelKey:this.labelKey});
      treeRootPath = TREEMap({labelKey:this.labelKey})[this.treeTypeKey];
      this.selectedPath.push(treeRootPath);
      this.treeRootPath=treeRootPath;
      if(this.list.length || this.isForceUseList){
        this.initTree(this.list);
      }else {
        this.getList();
      }
    });
  },
  computed: {
    _title() {
      return this.title === undefined ? window.$t('common.key87',{cm: '部门'}): this.title;
    },
    _trimKeyword() {
      return this.keyword; //inf-88085
    },
    isMultiple(){
      return !this.single;
    },
    pagingList() {
      return this.resultList.slice(0, (this.page + 1) * 20);
    },
    hasMore() {
      return this.pagingList.length < this.resultList.length;
    },
    pagingSearchResult() {
      return this.searchResult.slice(0, (this.searchPage + 1) * 20);
    },
    searchHasMore() {
      return this.pagingSearchResult.length < this.searchResult.length;
    },
    _clearTextStyle() {
      return this.curSelectedLength ? {} : { color: '#A3A6AD' };
    },
    disabledFunc(){
      return this.functionMap?.disabledFunc || undefined;
    },
    hideItemFunc(){
      return this.functionMap?.hideItemFunc || undefined;
    }
  },
  methods: {
    getComponentName(){
      let map={
        department:'department-item'
      };
      return map[this.treeTypeKey] || 'tree-item';
    },
    getSearchComponentName(){
      let map={
        department:'department-search-item'
      };
      return map[this.treeTypeKey] || 'tree-item';
    },
    focusSearch() {
      if (this.focusAnimateTimer) {
        clearTimeout(this.focusAnimateTimer);
      }
      // 100ms防止点击穿透失焦 移除
      this.focusAnimateTimer = setTimeout(() => {
        this.isFocusingSearch = true;
        if (this.updateScrollTimer) {
          clearTimeout(this.updateScrollTimer);
        }
        // 300ms更新scroll高度
        this.updateScrollTimer = setTimeout(() => {
          this.updateListHeight();
        }, 320);
      });
    },
    cancelSearch(){
      this.isFocusingSearch = false;
      this.keyword = '';
      if(this.depControl&&this.resultList.length){
        this.resultList=[];
      }
      if (this.updateScrollTimer) {
        clearTimeout(this.updateScrollTimer);
      }
      this.updateScrollTimer = setTimeout(() => {
        this.updateListHeight();
      }, 320);
    },
    clearAll() {
      if (this.curSelectedResults.length > 0) {
        this.curSelectedResults = [];
        this.curSelectedLength = 0;
        this.$handPlugin.toast.show(window.$t('commonForm-1.key77',{cm: '已清空'}));
        this.showSelectedModal = false;
      }
    },
    onTouchMove($event) {
      $event.preventDefault();
    },
    close() {
      this.showBody = false;
      this.$nextTick(() => {
        this.$emit('onCancel');
        this.popOpeningModal(this.popFn);
      });
    },
    updateListHeight(){
      let $refs = this.$refs || {};
      let titleContainer = $refs.titleContainer || {};
      let title = titleContainer.$el;
      let titleHeight = title ? parseFloat(window.getComputedStyle(title).height) : 0;
      let height = titleHeight   + 'px';
      this.listHeight = `calc(100% - ${height})`;
    },
    listenOnScroll(e) {
      if (e && e.y < -90) {
        this.showDepartmentPathFixed = true;
      } else {
        this.showDepartmentPathFixed = false;
      }
    },
    pushOpeningModal(fun) {
      store.commit('pushOpeningModal', fun);
    },
    popOpeningModal(fun) {
      store.commit('popOpeningModal', fun);
    },
    selectTreeItem(item) {
      if(this.functionMap?.disabledFunc(item)){
        return;
      }
        // 多选处理
        if (this.isMultiple) {
          if (this.isSelectedItem(item)) {
            this.curSelectedResults.deleteObjByKey([this.valueKey], item[this.valueKey]);
          } else {
            if(this.curSelectedResults.length>=this.maxSelectedNum&&this.maxSelectedNum) {
              this.$handPlugin.toast.show(window.$t('commonForm-1.key735',{arg1: this.maxSelectedNum,cm: '支持选择的最大数量为：{arg1}'}));
              return;
            }
            this.curSelectedResults.push(item);
          }
          this.curSelectedLength = this.curSelectedResults.length;
          return !1;
        }
        setTimeout(() => {
          setTimeout(() => {
            this.$emit(
              'onOk',
              [item]
            );
            this.addHistoryData(item);
            this.popOpeningModal(this.popFn);
          }, 300);
        }, 10);
    },
    spreadTreeItem(item,index){
      if (index === 0 && this.depControl && !this.isFocusingSearch) return;
      if (this.keyword) {
        this.loadingSearchData=true;
        this.searchPage=0;
        this.searchResult=item.childrenList;
        this.searchSelectedPath=treeCoreObj.getSearchBreadCrumbPath(item,this.treeRootPath).concat([]);
        this.loadingSearchData=false;
      } else {
        this.loadingDepartmentData=true;
        this.page = 0;
        this.resultList = item.childrenList || [];
        if (index !== undefined) {
          this.selectedPath.splice(index + 1, this.selectedPath.length - index - 1);
        } else {
          this.selectedPath.push(item);
        }
        this.loadingDepartmentData=false;
      }
      this.$nextTick(() => {
        if (this.$refs.searchScroller) {
          this.$refs.searchScroller.reset();
          this.$refs.searchScroller.forceUpdate();
        }
      });
    },
    isSelectedItem(selectedItem) {
      return this.curSelectedResults.some(item => item[this.valueKey] === selectedItem[this.valueKey]);
    },
    refresh() {
      let params=Object.assign({},this.extraParams);
      treeCoreObj.getListData(this.treeTypeKey,params ).then(res => {
        if (res && res.data) {
          this.$emit('update-list', res.data);
          this.selectedPath = [];
          this.selectedPath.push(treeRootPath);
          this.initTree(res.data);
          if (this.$refs.scroller) {
            this.$nextTick(() => {
              this.$refs.scroller.finishPullDown();
              setTimeout(() => {
                this.$refs.scroller.forceUpdate();
                this.$refs.scroller.reset();
              }, 60);
            });
          }

        }
      });
    },
    search: debounce(function () {
      this.loadingSearchData=true;

      if (this.depControl) {

        if (this._trimKeyword && this._trimKeyword.length) {
          let params=Object.assign({},this.extraParams,{keyword:this._trimKeyword});
          treeCoreObj.getListData(this.treeTypeKey,params ).then(res => {
            if (res && res.data) {
              let list = res.data;
              this.$emit('update-list', list);
              this.initTree(list);
              this.searchPage = 0;
              if(['department'].includes(this.treeTypeKey)){
                this.searchResult = treeCoreObj.search(this._trimKeyword);
              }else {
                this.searchResult=list;
              }

              this.$nextTick(() => {
                if (this.$refs.searchScroller) {
                  this.$refs.searchScroller.reset();
                  this.$refs.searchScroller.forceUpdate();
                }
              });
            }
          }).finally(()=>{
            this.loadingSearchData=false;
          });
        }
        return;
      }

      this.searchPage = 0;
      this.searchResult = treeCoreObj.search(this._trimKeyword);
      this.loadingSearchData=false;
      this.$nextTick(() => {
        if (this.$refs.searchScroller) {
          this.$refs.searchScroller.reset();
          this.$refs.searchScroller.forceUpdate();
        }
      });
    }, 400),
    // 加载更多数据
    loadMore() {
      this.page++;
      if (this.$refs.scroller) {
        this.$refs.scroller.finishPullUp();
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.scroller.forceUpdate();
            this.$refs.scroller.reset();
          }, 60);
        });
      }
    },
    // 加在更多搜索结果
    loadMoreResult() {
      this.searchPage++;
      this.$nextTick(() => {
        if (this.$refs.searchScroller) {
          this.$refs.searchScroller.finishPullUp();
          this.$nextTick(() => {
            this.$refs.searchScroller.forceUpdate();
            this.$refs.searchScroller.reset();
          });
        }
      });
    },
    getList(isSearch=false){
      let params=this.extraParams;
      this.loadingDepartmentData = true;
      treeCoreObj.getListData(this.treeTypeKey,params).then(res=>{
        this.loadingDepartmentData = false;
        this.$emit('update-list',res.data);
        !isSearch&&this.initTree(res.data);
      }).catch(error => {
        this.COMMON.errorHandle(error);
        this.loadingDepartmentData = false;
      });
      // if(isSearch){
      //
      // }
    },
    initTree(list) {
      if(!treeCoreObj){
        return;
      }
      this.page=0;
      treeCoreObj.initTree(list);
      this.resultList = treeCoreObj.getTargetNode().childrenList;
      treeRootPath.childrenList = this.resultList;

      //部门需要过滤list，控制虚拟部门的展示和是否下级可以展开
      treeCoreObj?.filterList(this.resultList);

      if (this.single&&this.value?.[0]?.[this.valueKey]) {
        let currentPath = treeCoreObj.getBreadCrumbPath(this.value[0]);//获取面包屑路径
        if (currentPath && currentPath.length) {
          this.selectedPath.push(...currentPath);
          this.resultList = this.selectedPath[this.selectedPath.length - 1].childrenList;
        }
      }
      this.$nextTick(() => {
        let dom = this.$refs.scroller;
        if (dom) {
          dom.forceUpdate();
          dom.reset();
        }
      });
    },
    /**
     * 初始化选择数据
     */
    initSelectedItems(list) {
      let selectedResults = [];
      selectedResults=(list || []).filter(item=>item[this.valueKey]);//过滤不存在valueKey的脏数据
      this.curSelectedResults = selectedResults;
      this.curSelectedLength = selectedResults.length;
    },
    openSelectedModal() {
      if (this.curSelectedLength) {
        this.showSelectedModal = true;
      } else {
        this.$handPlugin.toast.show(window.$t('commonForm-1.key78',{cm: '尚无选中内容'}));
      }
    },
    deleteItem(item){
      this.curSelectedResults.deleteObjByKey(this.valueKey, item[this.valueKey]);
      this.curSelectedLength = this.curSelectedResults.length;
    },
    ensure(){
      this.$emit(
        'onOk',
        this.curSelectedResults
      );
      this.addHistoryData(this.curSelectedResults,true);
      this.popOpeningModal(this.popFn);
    },
  },
  watch: {
    _trimKeyword(val, old) {
      if (val) {
        this.searchSelectedPath=[];
        this.loadingSearchData=true;
        this.search();
      } else {
        this.page = 0;
        this.searchResult = [];
        this.searchSelectedPath=[];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tree-select-modal {
  position: fixed;
  width: 100vw;
  height: 100%;
  top: 0;
  left: 0;
  &-mask {
    height: 100%;
    width: 100vw;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
  }
  .tree-select-modal-body {
    top: px(60);
    width: 100vw;
    height: calc(100% - 60px);
    overflow: hidden;
    position: absolute;
    .value-list-content {
      background-color: #fff;
      position: relative;
      height: 100%;
    }
    .scroller-container {
      background: #f9f9f9;
      height: 100%;
      width: 100%;
      .data-list {
        height: 100%;
      }
      &.has-footer {
        height: calc(100% - 100px);
      }
    }
    .search-result-container {
      background: #f9f9f9;
      height: 100%;
      width: 100%;
      .data-list {
        height: 100%;
      }
      &.has-footer {
        height: calc(100% - 100px);
      }
    }
    .scroller-content {
      z-index: 1;
      .blank-viewer {
        .blank-icon {
          height: px(256);
          width: px(256);
          margin: 0 auto;
          padding-top: px(240);
          .blank-icon-svg {
            font-size: px(256);
            color: $mainColor;
          }
        }

        .blank-text {
          font-weight: 400;
          font-size: px(28);
          line-height: px(28);
          color: #adadad;
          text-align: center;
          &-title {
            font-weight: 500;
            font-size: px(28);
            color: #252629;
            margin-bottom: px(16);
          }
        }
      }
    }
    .select-popup-bottom {
      height: px(100);
      width: 100%;
      padding: px(14) px(20);
      display: flex;
      background: #fff;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      bottom: 0;
      box-sizing: border-box;
      font-size: px(30);
      .selected-arrow {
        position: absolute;
        width: px(20);
        height: px(20);
        right: px(20);
        top: calc(50% - #{px(10)});
        transform: rotateZ(-90deg);
      }
      .selected-num-text {
        padding: 0 px(60);
        height: px(72);
        // width: px(500);
        border-radius: px(10);
        margin-right: px(15);
        color: $mainColor;
        flex-grow: 0;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        word-break: break-word;
        border: px(4) solid $mainColor;
        box-sizing: border-box;
        position: relative;
      }

      .select-ensure {
        height: px(72);
        border-radius: px(10);
        color: #fff;
        text-align: center;
        line-height: px(70);
        flex-shrink: 0;
        flex-grow: 1;
        background: $mainColor;
      }
    }
    .tree-item-name {
      .department-name {
        word-break: break-word;
        color: #252629;
        font-weight: 400;
        font-size: px(28);
        &.clamp {
          @include text-line(3);
        }
        &-mine {
          //box-sizing: border-box;
          background: #dde2e5;
          color: #495c6d;
          padding: px(2) px(8);
          line-height: px(32);
          font-weight: 400;
          border-radius: px(2);
          font-size: px(20);
        }
      }
    }
    .selected-page-con {
      top: px(96);
      overflow: scroll;
      .department-list {
        .department-item {
          .department-item-name {
            font-size: px(28);
            color: #505564;
            display: flex;
            align-items: center;
            padding: px(10) 0;
            margin: 0 px(30);
            min-height: px(72);
            position: relative;
            .delete-icon {
              width: px(32);
              height: px(32);
              border: px(4) solid $mainColor;
              border-radius: px(20);
              display: flex;
              justify-content: center;
              align-items: center;
              box-sizing: border-box;
              position: absolute;
              right: 0;
              &:after {
                content: '';
                width: px(12);
                height: px(4);
                background: $mainColor;
              }
            }
          }
          .department-name {
            word-break: break-word;
            color: #252629;
            font-weight: 400;
            font-size: px(28);
            &.clamp {
              @include text-line(3);
            }
            &-mine {
              //box-sizing: border-box;
              background: #dde2e5;
              color: #495c6d;
              padding: px(2) px(8);
              line-height: px(32);
              font-weight: 400;
              border-radius: px(2);
              font-size: px(20);
            }
          }
          .department-code {
            color: #71757e;
            font-weight: 400;
            font-size: px(24);
          }
          .department-path {
            word-break: break-all;
            color: #969aa2;
            font-weight: 400;
            font-size: px(24);
          }
        }
        .department-item-selected {
          background-color: #fff;
        }
      }
    }
  }
}
</style>
